import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useApolloClient } from "@apollo/react-hooks";

import Can from "../../components/can/can.component";
import Title from "../../components/title/title.component";
import ReviewCreate from "../../components/review/review-create.component";
import ReviewList from "../../components/review/review-list.component";
import ReviewsFromInternet from "../../components/review/review-internet.component";
import { useTranslation } from "react-i18next";

import { StyledContainer } from "../../components/styles/styled-container";
import {
  StyledReviewsBody,
  StyledReviewsSite,
  StyledReviewsWrapper,
} from "../../components/review/styled-reviews";

import { GET_USER_RBAC_DETAILS } from "../../graphql/queries/user.query";
import { reviews } from "../../rbac-consts";
import { helmetHtmlByLang } from "../../utils/consts.util";
import { cleanCanonicalUrl } from "../../utils/links.utils";

export const PaginationContext = React.createContext({
  currentPage: 1,
  itemsPerPage: 6,
});

const Reviews = () => {
  const client = useApolloClient();

  const { t } = useTranslation("reviews");

  const { userRole } = client.readQuery({
    query: GET_USER_RBAC_DETAILS,
  });

  let history = useHistory();
  let searchParams = new URLSearchParams(history.location.search);
  let currentPage = parseInt(searchParams.get("page") ?? 1);

  const paginationContext = useContext(PaginationContext);

  const [paginationInfo, setPaginationInfo] = useState({
    ...paginationContext,
    currentPage
  });

  useEffect(() => {
    setPaginationInfo({ ...paginationContext, currentPage });
  }, [currentPage]);

  return (
    <StyledContainer>
      <Helmet>
        <title>{t("meta.title")}</title>
        <meta
          name="description"
          content={t("meta.description")}
        />
        <meta
          content={t("meta.title")}
          property="og:title"
        />
        <meta
          content={t("meta.description")}
          property="og:description"
        />
        <meta
          name="robots"
          content="index, follow"
        />
        <link rel="canonical" href={cleanCanonicalUrl()} />
        <link rel="alternate" href={'https://' + window.location.hostname + '/reviews'} hrefLang={helmetHtmlByLang.ru} />
        <link rel="alternate" href={'https://' + window.location.hostname + '/ua/reviews'} hrefLang={helmetHtmlByLang.ua} />
        <link rel="alternate" href={'https://' + window.location.hostname + '/en/reviews'} hrefLang={helmetHtmlByLang.en} />
      </Helmet>
      <StyledReviewsWrapper>
        <PaginationContext.Provider value={paginationInfo}>
          <Title
            as="h1"
            title={t("header.title")}
            subtitle={t("header.subTitle")}
            className="reviews-title"
          />
          <StyledReviewsBody>
            <StyledReviewsSite className="reviews-site">
              <Can
                role={userRole}
                perform={reviews.CREATE}
                yes={() => <ReviewCreate />}
              />
              <div className="reviews-site__content">
                <ReviewList />
              </div>
            </StyledReviewsSite>
            <ReviewsFromInternet />
          </StyledReviewsBody>
        </PaginationContext.Provider>
      </StyledReviewsWrapper>
    </StyledContainer>
  );
};

export default React.memo(Reviews);
